import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { map, skipWhile, take, tap, withLatestFrom } from 'rxjs/operators';
import * as AppSelectors from 'src/app/state/app/app.selectors';
import { environment } from '../environments/environment';
import { AuthService } from './auth/auth.service';
import { UserRole } from './services/api.services';

@Injectable({ providedIn: 'root' })
export class DenyBusinessUserGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private store: Store,
    private router: Router) { }

  user$ = this.store.pipe(select(AppSelectors.getUser));

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.handle(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.handle(state.url);
  }

  private handle(url: string) {
    if (environment.testing) {
      return true;
    }

    return this.user$.pipe(
      skipWhile(user => !user || !this.authService.ready),
      map(user => {
        if (user.role > UserRole.ClientUser)
          return true;

        return new RedirectCommand(this.router.parseUrl('/home'));
      })
    );
  }
}
